(function($) {

    let $form = $("form.business-account-request-eu");

    if (!$form.length) {
        return;
    }

    $form.on('submit', function(e) {
        e.preventDefault();

        let url = ghostpress_params.ajax_url + "&action=business_account_request",
                data = $form.serializeArray();

        gp_ajax({
            url: url,
            type: "post",
            dataType: "json",
            data: data,
            show_loading: true
        })
                .done(function(response) {
                    if (response.success) {
                        // gp_ajax handles redirect automatically via data.redirect_url
                    } else {
                        $("html, body").animate({
                            scrollTop: $(".business-account-request-notices").offset().top - 100
                        }, 500);
                    }
                });
    });

})(jQuery);